import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main className="login-screen">
      <div className="login-card ptex">
        <div className="login-logo">404</div>
        <div className="login-subtitle">Page not found</div>
        <Link to="/clock" className="btn-primary login-btn">
          <i className="ph ph-arrow-left" />
          Back to clock
        </Link>
      </div>
    </main>
  );
}
